import { _COLORS } from "../../../utils/constants";

/**
 * An array of style objects for Excel export.
 * Each object defines a style that can be applied to cells in the exported Excel file.
 *
 * @type {Array<Object>}
 * @property {string} id - The unique identifier for the style.
 * @property {Object} interior - The interior style properties.
 * @property {string} interior.color - The color of the cell interior.
 * @property {string} interior.pattern - The pattern of the cell interior.
 */
export const excelStylesPlums = [
  {
    id: "month-header",
    interior: {
      color: _COLORS.headerAgGrid,
      pattern: "Solid",
    },
  },
];

/**
 * Converts form data into a row format.
 *
 * @param {Object} inputPlumsGroup - The group of input plums.
 * @param {Array} sources - The list of sources, each containing an id and name.
 * @param {Object} params - Additional parameters for processing.
 * @returns {Array} An array of row objects, each containing id, sourceName, sourceId, months, and inputPlumsId.
 */
export const formDataToRow = (inputPlumsGroup, sources, params) => {
  const rowMap = new Map();
  sources.forEach(({ id: sourceId, name: sourceName }) => {
    const [months, inputPlumsId] = getMonthsValue(
      inputPlumsGroup,
      sourceId,
      params,
    );
    rowMap.set(sourceId, {
      id: null,
      sourceName: sourceName,
      sourceId: sourceId,
      months: months,
      inputPlumsId: inputPlumsId,
    });
  });

  return Array.from(rowMap.values());
};

/**
 * Retrieves the values of months and their corresponding IDs from the input plums group based on the specified fiscal year, version, and source ID.
 *
 * @param {Array} inputPlumsGroup - Array of input plums objects.
 * @param {number} sourceId - The ID of the source to filter by.
 * @param {Object} options - Options object containing fiscal year and version.
 * @param {number} options.fiscalYear - The fiscal year to filter by.
 * @param {number} [options.version=1] - The version to filter by (default is 1).
 * @returns {Array} An array containing two objects:
 *   - months: An object where keys are fiscal months and values are amounts.
 *   - inputPlumsId: An object where keys are fiscal months and values are IDs.
 */
export const getMonthsValue = (
  inputPlumsGroup,
  sourceId,
  { fiscalYear, version = 1 },
) => {
  const months = {};
  const inputPlumsId = {};
  inputPlumsGroup.forEach(
    ({ amount, fiscalMonth, fiscalYear: fy, version: ver, sources, id }) => {
      if (fiscalYear === fy && version === ver && sourceId === sources.id) {
        months[fiscalMonth] = amount;
        inputPlumsId[fiscalMonth] = id;
      }
    },
  );

  return [months, inputPlumsId];
};
